function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import Typography from "@hig/typography";
import "@hig/fonts/build/ArtifaktElement.css";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";

const Text = ({
  handleTextClick,
  className,
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Typography, _extends({
  className: className,
  style: props,
  role: "button",
  onClick: handleTextClick
}, props), ReactHtmlParser(children));

Text.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired
};
export default styled(Text)`
  display: inline;
  > a {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    text-decoration: none;
    border-bottom: 1px dashed #999;

    :hover {
      border-bottom: 1px solid #999;
      cursor: pointer;
    }
  }
`;